import { render, staticRenderFns } from "./order-table-input.vue?vue&type=template&id=42ff19a2&scoped=true&"
import script from "./order-table-input.ts?vue&type=script&lang=ts&"
export * from "./order-table-input.ts?vue&type=script&lang=ts&"
import style0 from "./order-table-input.scss?vue&type=style&index=0&id=42ff19a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff19a2",
  null
  
)

export default component.exports